import * as R from 'ramda';

const getAdherenceReports = {
  fe2be: R.identity,
  be2fe: R.identity,
};

export default {
  getAdherenceReports
};
